import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterWrapper, CursorPointerWrapper, Mr3, FitRelativeWrapper,
  AbsoluteLeftTopWrapper, CustomBorderWrapper, Mt4, FlexCenterJustifyEndWrapper
} from 'wrappers';
import { Icon, SecondaryTextSm, PrimaryTextSm } from 'atoms';
import { IconTextButton } from 'molecules';
import {
  MoreFiltersSvg,
  TrashBinSvg,
  MoveOutSvg,
  MoveInSvg,
} from 'components/icons';
import React from 'react';
import internalState from './internalState';
import Controller from './controller';
import BoxDropdown from '../boxDropdown';
import { GeometrySvg } from 'utils/dropdownIcons/icons';
import TagsDropdown from '../tagsDropdown';
import { getObjectIcons } from 'utils';
import CalendarBoxDropdown from '../calendarBoxDropdown';

const containerRef = React.createRef();

export const definition = {
  name: 'MakeReadyFilters',
  controller: Controller,
  initialProps: ({ startMoveOutDate, startMoveInDate, endMoveOutDate, endMoveInDate, selectedFloorplanIds, selectedTagIds, floorplans, makeReadyCategories, noTagIds }) =>
    ({ startMoveOutDate, startMoveInDate, endMoveOutDate, endMoveInDate, selectedFloorplanIds, selectedTagIds, floorplans, makeReadyCategories, noTagIds }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({ startMoveOutDate, startMoveInDate, endMoveOutDate, endMoveInDate, selectedFloorplanIds, selectedTagIds }) => ({ startMoveOutDate, startMoveInDate, endMoveOutDate, endMoveInDate, selectedFloorplanIds, selectedTagIds, containerRef }),
          elements: [
            {
              component: wrap(Icon, Mr3),
              name: 'Icon',
              displayValue: ({ }) => MoreFiltersSvg({})
            },
            {
              component: SecondaryTextSm,
              renderIf: ({ isOpen }) => !isOpen,
              name: 'Text',
              displayValue: ({ }) => 'More filters'
            },
            {
              component: PrimaryTextSm,
              renderIf: ({ isOpen }) => isOpen,
              name: 'Text',
              displayValue: ({ }) => 'More filters'
            }
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '30px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({
                borderRadius: '8px',
                border: '1px solid #E3E3E3',
                background: '#FFFFFF',
                padding: '12px'
              }),
              elements: [
                {
                  component: BoxDropdown,
                  name: 'Floorplans',
                  renderIf: ({ makeReadyCategories }) => !!makeReadyCategories.find(c => c.type === 'floor_plan' && c.active),
                  bindings: ({ selectedFloorplanIds, floorplans }) => {
                    const entries = [];
                    floorplans.map((c) => entries.push({ id: c.id, label: c.name }));
                    return {
                      label: 'Floor Plan',
                      icon: GeometrySvg({ color: `${window.settings?.primary_color ?? '#1DBD6B'}`, width: 15, height: 15 }),
                      selectedIds: selectedFloorplanIds ?? [],
                      entries
                    };
                  }
                },
                {
                  component: wrap(TagsDropdown, Mt4),
                  name: 'Tags',
                  isListOf: { makeReadyCategory: ({ makeReadyCategories }) => makeReadyCategories.filter(c => c.type === 'tags' && c.active) },
                  bindings: ({ selectedTagIds, makeReadyCategory, noTagIds }) => {
                    const entries = [];
                    makeReadyCategory.tags?.filter(t => t.status).map((c) => entries.push({ id: c.id, label: c.name, color: c.color }));
                    return {
                      label: makeReadyCategory.name,
                      icon: getObjectIcons({ color: window?.settings?.primary_color ?? '#1DBD6B', width: 15, height: 15 })[makeReadyCategory?.icon_name ?? 'Tag'],
                      selectedIds: selectedTagIds ?? [],
                      entries,
                      noTagIds,
                      makeReadyCategory
                    };
                  }
                },
                {
                  component: wrap(CalendarBoxDropdown, Mt4),
                  name: 'MoveInDate',
                  isButton: true,
                  bindings: ({ startMoveInDate, endMoveInDate }) => ({ startDate: startMoveInDate, endDate: endMoveInDate, label: 'Move in', icon: MoveOutSvg({}) }),
                },
                {
                  component: wrap(CalendarBoxDropdown, Mt4),
                  name: 'MoveOutDate',
                  isButton: true,
                  bindings: ({ startMoveOutDate, endMoveOutDate }) => ({ startDate: startMoveOutDate, endDate: endMoveOutDate, label: 'Move out', icon: MoveInSvg({}) }),
                },
                {
                  component: wrap(wrap(IconTextButton, Mt4), FlexCenterJustifyEndWrapper),
                  name: 'ResetFilters',
                  renderIf: ({ startMoveOutDate, startMoveInDate, endMoveOutDate, endMoveInDate, selectedFloorplanIds, selectedTagIds }) => startMoveOutDate || startMoveInDate || endMoveOutDate || endMoveInDate || selectedFloorplanIds?.length > 0 || selectedTagIds?.length > 0,
                  bindings: ({ }) => ({ icon: TrashBinSvg({}), title: 'Clear filters' })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
